import * as React from 'react'

const SvgWarningSquareIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={21} height={20} viewBox="0 0 21 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 12.5a.937.937 0 100 1.875.937.937 0 000-1.875zm-.625-6.875h1.25v5.625h-1.25V5.625zM16.75 17.5H4.25c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25zM4.25 3.75v12.5h12.5V3.75H4.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgWarningSquareIcon
